import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  sendDefaultPii: false,
  beforeSend(event) {
    // Strip request body — may contain policy HTML content (OWASP A02)
    if (event.request) {
      delete event.request.data;
    }
    // Scrub UUIDs from breadcrumb URLs — avoids leaking clinic/policy IDs
    if (Array.isArray(event.breadcrumbs?.values)) {
      event.breadcrumbs.values = event.breadcrumbs.values.map((crumb) => {
        if (crumb.data?.url) {
          crumb.data.url = crumb.data.url.replace(
            /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
            "[id]"
          );
        }
        return crumb;
      });
    }
    return event;
  },
});

const FallbackUI = () => (
  <div style={{ padding: "2rem", fontFamily: "sans-serif", textAlign: "center" }}>
    <h2 style={{ marginBottom: "0.5rem" }}>Something went wrong</h2>
    <p style={{ color: "#666" }}>
      An unexpected error occurred. Please refresh the page.
    </p>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<FallbackUI />}>
    <App />
  </Sentry.ErrorBoundary>
);